import * as React from "react";
const SvgFiRrCameraSecurity = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 0H7C4.243 0 2 2.243 2 5v10c0 2.757 2.243 5 5 5h.033a6 6 0 0 0-.674.806 1.93 1.93 0 0 0-.135 2.028C6.599 23.553 7.362 24 8.215 24h7.568c.854 0 1.617-.447 1.991-1.166a1.93 1.93 0 0 0-.135-2.029 6 6 0 0 0-.674-.805h.033c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5zm-.998 21.908c-.007.018-.068.092-.218.092H8.216c-.127 0-.191-.053-.211-.053h-.003c.844-1.202 2.375-1.948 3.999-1.948s3.159.748 4.002 1.908zM20 15c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3zM12 5c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5m0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3"
    />
  </svg>
);
export default SvgFiRrCameraSecurity;
